import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/icon-create-account.svg'
import _imports_1 from '@/assets/icons/user-document.svg'
import _imports_2 from '@/assets/icons/icon-dashboard-large.svg'
import _imports_3 from '@/assets/icons/icon-powered-by.svg'


const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal--title" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "modal-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    class: "max-width",
    isOpen: $props.isOpen,
    onClose: $setup.onClose,
    "transition-name": $props.transitionName
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, "Reserve Lot " + _toDisplayString($props.lotTitle), 1),
          _createElementVNode("div", _hoisted_4, "Welcome to " + _toDisplayString($props.estateTitle) + " digital reservation platform. Here’s how it works:", 1)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "step-instructions" }, [
          _createElementVNode("div", { class: "step" }, [
            _createElementVNode("img", { src: _imports_0 }),
            _createElementVNode("div", { class: "title" }, "Step 1"),
            _createElementVNode("div", { class: "description" }, "Register to create a free account")
          ]),
          _createElementVNode("div", { class: "step" }, [
            _createElementVNode("img", { src: _imports_1 }),
            _createElementVNode("div", { class: "title" }, "Step 2"),
            _createElementVNode("div", { class: "description" }, "Complete digital Expression of Interest")
          ]),
          _createElementVNode("div", { class: "step" }, [
            _createElementVNode("img", { src: _imports_2 }),
            _createElementVNode("div", { class: "title" }, "Step 3"),
            _createElementVNode("div", { class: "description" }, "Track your purchase from your Dashboard")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "button default medium primary register",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openRegistrationModal()))
          }, "Register"),
          _createElementVNode("p", null, [
            _cache[2] || (_cache[2] = _createTextVNode("Already have an account? ", -1)),
            _createElementVNode("a", {
              class: "link",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openLoginModal()))
            }, "Login")
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("img", { src: _imports_3 }, null, -1))
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "transition-name"]))
}